var map = {
	"./bar-chart.svg.icon": 813,
	"./down-circle.svg.icon": 814,
	"./line-chart.svg.icon": 815,
	"./question-mark.svg.icon": 816,
	"./summary-table.svg.icon": 817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 812;